const TransportMethods = {
  SHIP: 'SHIP',
  AIRPLANE: 'AIRPLANE'
}
export default TransportMethods;